import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { getHomeRoute } from '../utils/permissions';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Alert, AlertDescription } from '../components/ui/alert';
import { setStoreTimezone } from '../utils/datetime';
import { forgetStore } from '../utils/tenant';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [branding, setBranding] = useState({ logo_base64: null });
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${API}/settings/company/branding`).then((r) => {
      setBranding(r.data || {});
      if (r.data && r.data.timezone) setStoreTimezone(r.data.timezone);
    }).catch(() => {});
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(email, password);
    
    if (result.success) {
      navigate(getHomeRoute(result.user));
    } else {
      setError(result.error);
    }
    
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-lg border border-slate-200 p-8 shadow-sm">
          <div className="text-center mb-8">
            {branding.logo_base64 && (
              <img src={branding.logo_base64} alt="Logo da loja" className="h-20 w-20 rounded-full object-cover mx-auto mb-3" data-testid="login-company-logo" />
            )}
            <h1 className="text-4xl font-black text-slate-900 tracking-tight">Smart Flow</h1>
            <p className="text-xs uppercase tracking-[0.2em] text-slate-500 mt-2">Sistema de vendas</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email-input"
                required
                className="rounded-md"
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="password">Senha</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password-input"
                required
                className="rounded-md"
              />
            </div>

            {error && (
              <Alert variant="destructive" data-testid="login-error">
                <AlertDescription>{error}</AlertDescription>
              </Alert>
            )}

            <Button
              type="submit"
              disabled={loading}
              data-testid="login-submit-button"
              className="w-full bg-blue-600 hover:bg-blue-700 rounded-md transition-colors duration-200 active:scale-95"
            >
              {loading ? 'Entrando...' : 'Entrar'}
            </Button>
          </form>

          <p className="text-center mt-6 text-sm text-slate-600">
            <button
              type="button"
              onClick={() => { forgetStore(); navigate('/entrar'); }}
              data-testid="login-switch-store"
              className="text-blue-600 hover:text-blue-700 font-medium transition-colors"
            >
              Acessar outra loja
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};